import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DesignElementBase } from "./base";
import { FigmaNodeReferenceData } from "./data/figma-node-reference";

export const FigmaNodeReferenceOrigin = z.object({
  sourceId: z.string(),
  parentName: z.string().optional(),
});

export const FigmaNodeReference = DesignElementBase.extend({
  data: FigmaNodeReferenceData,
  origin: FigmaNodeReferenceOrigin,
});

export type FigmaNodeReferenceOrigin = z.infer<typeof FigmaNodeReferenceOrigin>;
export type FigmaNodeReference = z.infer<typeof FigmaNodeReference>;

export type CreateFigmaNodeReference = DbCreateInputOmit<FigmaNodeReference>;
export type UpdateFigmaNodeReference = OmitStrict<DbUpdate<FigmaNodeReference>, "designSystemVersionId">;

export type FigmaNodeReferenceDiff = {
  toUpdate: UpdateFigmaNodeReference[];
};
